const Category = ["MCV", "MCH", "MCHC", "RDWc"];

export default Category;
